"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInputControl = validateInputControl;
exports.allChildrenMatchTypes = exports.areComponentsEqual = void 0;

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * This is a helper function to do input value/defaultValue props validation.
 *
 * @param {object} props - This is the props object.
 * @param {string} propName - prop name
 * @param {string} componentName - component name
 * @returns {Error} - return an Error or undefined.
 */
function validateInputControl(_ref, propName, componentName) {
  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange;

  var valueType = _typeof(value);

  var valueIsNull = value === null;
  var isControlled = valueType !== 'undefined';

  if (value && defaultValue) {
    // eslint-disable-next-line max-len
    return new Error('StateHolder contains an input of type undefined with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components');
  }

  if (isControlled) {
    if (valueIsNull) {
      // eslint-disable-next-line max-len
      return new Error("`value` prop on `".concat(componentName, "` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components."));
    }

    if (!onChange) {
      // eslint-disable-next-line max-len
      return new Error('You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.');
    }
  }
}
/**
 * Compare two components and returns true if they are equal.
 * Note: special handling for dev vs production env handling.
 * See discussion for using tools like react-hot-loader:
 * https://github.com/gatsbyjs/gatsby/issues/3486#issuecomment-364167698
 *
 * @param {element} inboundElement - inbound component to test
 * @param {element} CurrentElement - current component to compare against
 * @param {object} currentElementProps - Dummy props to avoid PropType errors (when
 *   instantiated for comparision)
 * @returns {boolean} - true if components are same
 */


var areComponentsEqual = function areComponentsEqual(inboundElement, CurrentElement, currentElementProps) {
  return (0, _isObject2.default)(inboundElement) && inboundElement.type && (inboundElement.type === CurrentElement || inboundElement.type === _react.default.createElement(CurrentElement, currentElementProps).type);
};
/**
 * Compare array of children and returns true if all children match a valid Component set
 *
 * @param {element} children - children to compare
 * @param {array.<{comp: child, props: Object}>} allowedChildren - allowed children that will be compared against
 * @param {object} [optionsCB] - object that contains success/fail callbacks
 * @param {function} [optionsCB.success] - success callback if child matches. Passes `child` to cb
 * @param {function} [optionsCB.fail] - fail callback if child matches. Passes `child` to cb
 * @returns {boolean} - true if components are same
 */


exports.areComponentsEqual = areComponentsEqual;

var allChildrenMatchTypes = function allChildrenMatchTypes(children, allowedChildren, optionsCB) {
  var allChildrenMatch = true;

  _react.default.Children.forEach(children, function (child) {
    var childMatchedType = (0, _findIndex2.default)(allowedChildren, function (o) {
      return areComponentsEqual(child, o.comp, o.props);
    }) > -1; // Fail Match

    if (!childMatchedType) {
      allChildrenMatch = false;

      if (optionsCB && optionsCB.fail) {
        optionsCB.fail(child);
      } // Success Match

    } else if (optionsCB && optionsCB.success) {
      optionsCB.success(child);
    }
  });

  return allChildrenMatch;
};

exports.allChildrenMatchTypes = allChildrenMatchTypes;